import Grid from "@material-ui/core/Grid";
import { CheckBox, withNamespace } from "components/Form/FormikControls";
import React from "react";
import { RuleOutputFormatField } from "./RuleOutputFormatField";

export interface PresentationFormattingFormValues {
  quantity_output_format: string;
  unit_amount_output_format: string;
  include_if_zero: boolean;
}

interface PresentationFormattingFormProps {
  namespace?: string;
  quantityOutputFormatOptions: Array<{ value: string; label: string }>;
  unitAmountOutputFormatOptions: Array<{ value: string; label: string }>;
}

export function PresentationFormattingForm(
  props: PresentationFormattingFormProps,
) {
  const {
    namespace: ns = "",
    quantityOutputFormatOptions,
    unitAmountOutputFormatOptions,
  } = props;

  return (
    <>
      <Grid item xs={6}>
        <RuleOutputFormatField
          name="quantity_output_format"
          options={quantityOutputFormatOptions}
          label="Units Format"
        />
      </Grid>
      <Grid item xs={6}>
        <RuleOutputFormatField
          name="unit_amount_output_format"
          options={unitAmountOutputFormatOptions}
          label="Unit Price Format"
        />
      </Grid>
      <Grid item xs={6}>
        <CheckBox
          name={withNamespace(ns, "include_if_zero")}
          label="Include Zero Value Entries"
          tooltip="Include ledger entries that have 0 value."
        />
      </Grid>
    </>
  );
}
